import React from "react";
import { Redirect } from "react-router-dom";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
//import Button from "components/CustomButtons/Button.jsx";
//import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
//import CardAvatar from "components/Card/CardAvatar.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

//import avatar from "assets/img/faces/avatar.jpg";

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";

import { feathersAuth } from "helpers/feathers";

class Root extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      redirect: ""
    };
  }

  setRedirect = url => {
    if (this._isMounted)
      this.setState({
        redirect: url
      });
  };

  renderRedirect = () => {
    if (this.state.redirect !== "") {
      return <Redirect to={this.state.redirect} />;
    }
  };

  componentDidMount() {
    this._isMounted = true;

    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        if (this._isMounted) this.setState({ cardAnimaton: "" });
      }.bind(this),
      0
    );
    setTimeout(() => this.authenticate(), 0);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async authenticate() {
    //console.log("ROOT: authenticate");
    //console.log(feathersAuth);
    if (!feathersAuth.isAuthenticated) {
      //console.log("ROOT: not authenticated");
      await feathersAuth.authenticate();
      //console.log("ROOT: end authenticate");
      if (feathersAuth.isAuthenticated) {
        //console.log("ROOT: is authenticated");
        this.setRedirect("/dashboard");
      } else {
        //console.log("ROOT: redirect to auth");
        await feathersAuth.signout();
        //setTimeout(function() { window.location = "/auth/cityadpro/"; }, 60000);
        window.location = "/auth/cityadpro/";
      }
    } else {
      //console.log("ROOT: redirect to dashboard");
      this.setRedirect("/dashboard");
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        {this.renderRedirect()}
        <form>
          <Card
            profile
            className={
              classes.customCardClass + " " + classes[this.state.cardAnimaton]
            }
          >
            <CardBody profile>
              <GridContainer
                direction="row"
                justify="center"
                alignItems="center"
              >
                <GridItem>
                  <ReactLoading type={"spinningBubbles"} color={"#4caf50"} />
                </GridItem>
                <GridItem>
                  <h4 className={classes.cardTitle}>...loading app</h4>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter className={classes.justifyContentCenter} />
          </Card>
        </form>
      </div>
    );
  }
}

Root.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(lockScreenPageStyle)(Root);
